module.exports = __webpack_public_path__ + "static/Fitness-27ae0f9d55b5f0f113093264bd39b676.svg";